<template>
  <v-container>
    <v-row>
      <v-col cols="12">
        <UserForm
          title="Nový uživatel"
          v-model="dealer"
          @save="save"
          :userAdd="true"
          @certificateChanged="fileUpload"
          :loading="loading"
        />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapActions } from 'vuex';
import UserForm from '@/components/forms/UserForm.vue';
import { SUCCESS_MESSAGES } from '@/enums/success-messages';

export default {
  name: 'UserAdd',
  components: {
    UserForm,
  },
  data() {
    return {
      dealer: {},
      loading: false,
    };
  },
  methods: {
    ...mapActions({
      createDealer: 'users/createDealer',
    }),
    async save(dealer) {
      this.loading = true;
      this.createDealer(dealer)
        .then((response) => {
          if (response.status === 200) {
            this.$notify.success({
              title: SUCCESS_MESSAGES.userAddSaveSuccessMessage(
                response.data.firstName,
                response.data.lastName,
              ),
              showClose: true,
              type: 'success',
            });
            this.$router.push({
              name: 'users',
            });
          }
        })
        .finally(() => {
          this.loading = false;
          this.dealer.certificateFile = null;
        });
    },
    fileUpload(event) {
      this.dealer.certificateFile = event;
    },
  },
};
</script>
